export function OutlineShapesIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9375 21H20.895V14.0425H13.9375V21Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.416 9.95754C19.3373 9.95754 20.8948 8.40004 20.8948 6.47877C20.8948 4.5575 19.3373 3 17.416 3C15.4948 3 13.9373 4.5575 13.9373 6.47877C13.9373 8.40004 15.4948 9.95754 17.416 9.95754Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.84144 13.584L5.56732 15.8698L3 16.3756L4.77995 18.2939L4.46977 20.8947L6.84144 19.7923L9.21789 20.8947L8.90771 18.2939L10.6877 16.3756L8.12033 15.8698L6.84144 13.584Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.0705 3L3 10.053H11.1458L7.0705 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
